import {
    ApplicationRef,
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    EmbeddedViewRef,
    Injectable,
    Injector,
    Type
} from '@angular/core';

import { ShDynamicDialogComponent } from '../components/dynamic-dialog/dynamic-dialog.component';
import { DialogConfig } from '../entities/dialog-config.entity';
import { DialogRef } from '../entities/dialog-ref.class';
import { DynamicDialogInjector } from '../entities/dynamic-dialog.injector';

@Injectable({ providedIn: 'root' })
export class ShDynamicDialogService {
    constructor(
        private readonly componentFactoryResolver: ComponentFactoryResolver,
        private readonly appRef: ApplicationRef,
        private readonly injector: Injector
    ) {}

    public open<T>(componentType: Type<any>, config: DialogConfig): DialogRef<T> {
        const dialogRef: DialogRef<T> = this.appendDialogComponentToBody(componentType, config);
        return dialogRef;
    }

    private appendDialogComponentToBody<T>(componentType: Type<any>, config: DialogConfig): DialogRef<T> {
        const map: WeakMap<object, any> = new WeakMap();
        map.set(DialogConfig, config);

        const dialogRef: DialogRef<T> = new DialogRef<T>();
        map.set(DialogRef, dialogRef);

        const componentFactory: ComponentFactory<ShDynamicDialogComponent> =
            this.componentFactoryResolver.resolveComponentFactory(ShDynamicDialogComponent);
        const componentRef: ComponentRef<ShDynamicDialogComponent> = componentFactory.create(
            new DynamicDialogInjector(this.injector, map)
        );
        componentRef.instance.childComponentType = componentType;
        this.appRef.attachView(componentRef.hostView);

        const domElem: HTMLElement = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        document.body.appendChild(domElem);

        dialogRef.afterClosed$.subscribe({ complete: () => this.removeDialogComponentFromBody(componentRef) });
        componentRef.instance.onClose$.subscribe(() => dialogRef.close());

        return dialogRef;
    }

    private removeDialogComponentFromBody(componentRef: ComponentRef<ShDynamicDialogComponent>): void {
        this.appRef.detachView(componentRef.hostView);
        componentRef.destroy();
    }
}
